"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVisitedOffersEventType = void 0;
let EVisitedOffersEventType = exports.EVisitedOffersEventType = /*#__PURE__*/function (EVisitedOffersEventType) {
  EVisitedOffersEventType["SetStorageSettings"] = "setStorageSettings";
  EVisitedOffersEventType["GetVisitedOffers"] = "getVisitedOffers";
  EVisitedOffersEventType["SetOfferVisited"] = "setOfferVisited";
  return EVisitedOffersEventType;
}({});